//  ----------      START   IMPORT  BLOCK       ----------
import React from "react";
import { Nav } from "react-bootstrap";
import { medStaffNavLinks, generalUserNavLinks } from "./MedStaffNavLinks";
import CustomNavLink from "./CustomNavLink";
import { useLanguage } from "../../API/Context/LanguageContext";
import { useDashboardPreference } from "../../API/Context/AppUIContext";
//  ----------      END   IMPORT  BLOCK       ----------

interface SidebarProps {
  onSelect: (key: string) => void;
  activeItem: string;
}

const Sidebar: React.FC<SidebarProps> = ({ onSelect, activeItem }) => {
  const { lan } = useLanguage();
  const { isProDashboardActive } = useDashboardPreference();

  const navlinks = isProDashboardActive ? medStaffNavLinks : generalUserNavLinks;

  return (
    <div className="bg-light border-right" id="sidebar-wrapper">
      <Nav className="flex-column" activeKey={activeItem}>
        {navlinks.map((link) => (
          <CustomNavLink
            key={link.key}
            handleSelect={onSelect}
            tooltip={link.tooltip[lan]}
            img_path={link.img_path}
            eventKey={link.key}
            active={activeItem === link.key}
          />
        ))}
      </Nav>
    </div>
  );
};

export default Sidebar;